import {useSelector} from 'react-redux'
import {ACCOMMODATION_FIXED_HEADER_HEIGHT} from 'components/Accommodation/AccommodationFixedHeader/AccommodationFixedHeader'
import {getSearchDesktopHeaderHeight} from 'modules/search/selectors'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'

const MOBILE_OFFSET = 10

export const useAccommodationPageScrollTopOffset = () => {
  const {isDesktopMd, isDesktopLg, isMobile} = useDeviceLayout()

  const isSearchBoxSticky = isDesktopMd || isDesktopLg

  const searchDesktopHeaderHeight =
    useSelector(getSearchDesktopHeaderHeight) ?? 0

  const searchBoxOffset = isSearchBoxSticky ? searchDesktopHeaderHeight : 0
  const navBarOffset = isMobile
    ? MOBILE_OFFSET
    : ACCOMMODATION_FIXED_HEADER_HEIGHT

  const totalOffset = searchBoxOffset + navBarOffset

  return totalOffset
}
